import "../mtrl/mtrlEd.scss";
import React, { useEffect, useState } from "react";

import SteelCurve from "../mtrl/SteelCurve";
import TimberCurve from "../mtrl/TimberCurve";
import ReinfCurve from "../mtrl/NewReinfCurve";
import ConcCurve from "../mtrl/ConCurve";
import { ng } from "@common/ngds";

import SvgIcon from "./ui-components/ng-icons/icons/SvgIcon";
import { viewportColors } from "./ViewportStyles";

export type MaterialRecord = Record<string, any>;

export interface MaterialSvg {
  w: number;
  h: number;
  origo: {
    x: number;
    y: number;
  };
  max: {
    x: number;
    y: number;
  };
  pad: number;
}

export interface SvgCurve {
  stroke: string;
  width: string;
  dash: string;
  data: string;
}

export interface SvgTxt {
  x: string;
  y: string;
  style: {
    fontSize: string;
    fontStyle: string;
    fontWeight?: string;
  };
  text: string;
}

interface DrawMtrlCurveProps {
  mtrl: MaterialRecord;
  svg: MaterialSvg;
}

const ConvertStr2Html = (txt: string) => {
  const parser = new DOMParser();
  const tmp = parser.parseFromString(txt, "text/html");

  return tmp;
};

function Axes(props: DrawMtrlCurveProps) {
  const { mtrl, svg } = props;

  const xCoord = [(svg.w * (1 - svg.pad)).toString(), (svg.w * svg.pad).toString()];
  const yCoord = [(svg.h * (1 - svg.pad)).toString(), (svg.h * svg.pad).toString()];

  const xPnt = xCoord[0] + "," + yCoord[0];
  const yPnt = xCoord[1] + "," + yCoord[1];

  const xArrow = "l-10,-5 l0,10 l10,-5";
  const yArrow = "l-5,10 l10,0 l-5,-10";

  const xTxt = [(svg.w * (1 - svg.pad) + 5).toString(), (svg.h * (1 - svg.pad) + 7).toString()];
  const yTxt = [(svg.w * svg.pad - 7).toString(), (svg.h * svg.pad - 5).toString()];

  let xAxis = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " " + "L" + xPnt + " " + xArrow;
  let yAxis = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " " + "L" + yPnt + " " + yArrow;

  return (
    <>
      {/* <rect
          width={svg.w}
          height={svg.h}
          style={{
            fill: "rgb(255,255,255)",
            strokeWidth: "2",
            stroke: "rgb(0,0,0)",
          }}
        />
*/}
      <path id="X-axis" fill="black" stroke="black" strokeWidth="2" d={xAxis} />

      <text id="x-label" x={xTxt[0]} y={xTxt[1]} style={{ fontSize: "30px" }}>
        &epsilon;
      </text>

      <path id="Y-axis" fill="black" stroke="black" strokeWidth="2" d={yAxis} />

      <text id="y-label" x={yTxt[0]} y={yTxt[1]} style={{ fontSize: "30px" }}>
        &sigma;
      </text>
    </>
  );
}

function Curve(props: DrawMtrlCurveProps) {
  const { mtrl, svg } = props;

  let curves: SvgCurve[] = [];
  let txts: SvgTxt[] = [];

  switch (mtrl["materialCategory"]) {
    default:
    case "MTRL_CONCRETE": {
      // if (!activeMtrl.valObj.hasOwnProperty("compression")) break;
      // const fcc = Number(activeMtrl.valObj["compression"].value);
      // if (!activeMtrl.valObj.hasOwnProperty("compressiveStrain2")) break;
      // const ec2 = Number(activeMtrl.valObj["compressiveStrain2"].value);

      // if (!activeMtrl.valObj.hasOwnProperty("ultimateCompressiveStrain2"))
      //   break;
      // const ecu2 = Number(
      //   activeMtrl.valObj["ultimateCompressiveStrain2"].value
      // );
      // if (!activeMtrl.valObj.hasOwnProperty("n")) break;
      // const n = Number(activeMtrl.valObj["n"].value);
      // if (fcc > 0 && ec2 > 0 && ecu2 > 0 && n > 0) {
      [curves, txts] = ConcCurve(mtrl, svg);
      // }

      break;
    }

    case "MTRL_STEEL": {
      // if (!activeMtrl.valObj.hasOwnProperty("elasticityModulus")) {
      //   break;
      // }
      // const E = Number(activeMtrl.valObj["elasticityModulus"].value);

      // if (!activeMtrl.valObj.hasOwnProperty("yieldStrengths")) {
      //   break;
      // }
      // const fy = Number(
      //   activeMtrl.valObj["yieldStrengths"].value[0]["strength"]
      // );

      // if (!activeMtrl.valObj.hasOwnProperty("ultimateTensileStrengths")) {
      //   break;
      // }
      // const fu = Number(
      //   activeMtrl.valObj["ultimateTensileStrengths"].value[0]["strength"]
      // );

      // if (E > 0 && fy > 0 && fu > 0) {
      [curves, txts] = SteelCurve(mtrl, svg);
      // }

      break;
    }

    case "MTRL_TIMBER": {
      [curves, txts] = TimberCurve(mtrl, svg);
      break;
    }

    case "MTRL_REINFORCEMENT": {
      // if (!activeMtrl.valObj.hasOwnProperty("elasticityModulus")) break;
      // const E = Number(activeMtrl.valObj["elasticityModulus"].value);

      // if (!activeMtrl.valObj.hasOwnProperty("yieldStrength")) break;
      // const fy = Number(activeMtrl.valObj["yieldStrength"].value);

      // if (!activeMtrl.valObj.hasOwnProperty("ultimateStrength")) break;
      // const fu = Number(activeMtrl.valObj["ultimateStrength"].value);

      // if (!activeMtrl.valObj.hasOwnProperty("k")) break;
      // const k = Number(activeMtrl.valObj["k"].value);

      // if (E > 0 && fy > 0 && fu >= fy && k > 0) {
      [curves, txts] = ReinfCurve(mtrl, svg);
      // }
      break;
    }
  }

  return (
    <>
      {curves.map((curve, index) => {
        return (
          <path
            id={"curve-" + index}
            key={"path-" + index}
            fill="none"
            stroke={curve.stroke}
            strokeWidth={curve.width}
            strokeDasharray={curve.dash}
            d={curve.data}
          />
        );
      })}

      {txts.map((txt, index) => {
        return (
          <text id={"curve-txt-" + index} key={"curve-txt-" + index} x={txt.x} y={txt.y} style={txt.style}>
            {ConvertStr2Html(txt.text).documentElement.outerText}
          </text>
        );
      })}
    </>
  );
}

const DrawMtrlCurve = (props: DrawMtrlCurveProps) => {
  const { mtrl, svg } = props;
  const vb = "0 0 " + svg.w.toString() + " " + svg.h.toString();
  return (
    <svg viewBox={vb}>
      (mtrl.hasOwnProperty("materialCategory") &&
      <>
        <Axes mtrl={mtrl} svg={svg} />
        <Curve mtrl={mtrl} svg={svg} />
      </>
      )
    </svg>
  );
};

interface ConcreteCIconProps {
  size?: number;
  color?: string;
}

const ConcreteCIcon: React.FC<ConcreteCIconProps> = (props) => (
  <SvgIcon {...props}>
    {
      <path d="M20.581 12c0 4.739-3.842 8.581-8.581 8.581s-8.581-3.842-8.581-8.581c0-4.739 3.842-8.581 8.581-8.581s8.581 3.842 8.581 8.581z" />
    }{" "}
  </SvgIcon>
);

export default DrawMtrlCurve;

export type MaterialCategory = ng.sections.MaterialCategory;

function GetMtrlClr(
  mtrl:
    | MaterialCategory
    | "MATERIAL_CATEGORY_CONCRETE"
    | "MATERIAL_CATEGORY_STEEL"
    | "MATERIAL_CATEGORY_TIMBER"
    | "MATERIAL_CATEGORY_REINFORCEMENT",
) {
  //https://htmlcolorcodes.com/
  switch (mtrl) {
    case ng.sections.MaterialCategory.MATERIAL_CATEGORY_CONCRETE:
    case "MATERIAL_CATEGORY_CONCRETE":
      return viewportColors.geomFillConcrete;
    case ng.sections.MaterialCategory.MATERIAL_CATEGORY_STEEL:
    case "MATERIAL_CATEGORY_STEEL":
      return viewportColors.geomFillSteel;
    case ng.sections.MaterialCategory.MATERIAL_CATEGORY_TIMBER:
    case "MATERIAL_CATEGORY_TIMBER":
      return viewportColors.geomFillTimber;
    case "MATERIAL_CATEGORY_REINFORCEMENT":
      // todo(Gustav): is this used???
      return "#616A6B";
    default:
      return "#99A3A4";
  }
}

function getSec(guid: string, input: ng.input.IData) {
  if (input == null) return null;

  let sec = input.secDb?.find((m) => m.id?.guid === guid);

  return sec ?? null;
}

export { ConcreteCIcon, GetMtrlClr, getSec };
